module.exports = __webpack_public_path__ + "static/media/icon_emergencia.23802be9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_emergencia.svg
// module id = 522
// module chunks = 0